import { render, staticRenderFns } from "./SolutionModal.vue?vue&type=template&id=7c687c68"
import script from "./SolutionModal.vue?vue&type=script&lang=js"
export * from "./SolutionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports